// Shared 0-decimal USD formatter for all scholarship money displays (summary cards,
// players table, totals strip, depth chart) so dollar rendering never drifts between views.
const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

export const formatMoney = (value: number): string => moneyFormatter.format(value);
